import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@ui/primitives';
import { Info } from 'lucide-react';
import { WithTooltip } from './WithTooltip';
export function NpmLinkRenderer(param) {
    let { value, data } = param;
    if (!value.version) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-full items-center gap-1",
            children: "-"
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: value.hasTooltip ? 'flex h-full items-center gap-1 text-destructive' : 'flex h-full items-center gap-1',
        children: [
            /*#__PURE__*/ _jsx(WithTooltip, {
                name: value.version,
                showName: false,
                styleBold: false,
                children: /*#__PURE__*/ _jsx("a", {
                    href: "https://www.npmjs.com/package/".concat(data.name, "/v/").concat(value.version),
                    target: "_blank",
                    rel: "noreferrer",
                    className: "text-primary underline-offset-4 hover:underline",
                    children: value.version
                })
            }),
            value.hasTooltip && /*#__PURE__*/ _jsx(TooltipProvider, {
                children: /*#__PURE__*/ _jsxs(Tooltip, {
                    children: [
                        /*#__PURE__*/ _jsx(TooltipTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx(Info, {
                                className: "h-4 w-4 cursor-pointer text-muted-foreground"
                            })
                        }),
                        /*#__PURE__*/ _jsx(TooltipContent, {
                            children: /*#__PURE__*/ _jsx("p", {
                                children: data.tooltipText
                            })
                        })
                    ]
                })
            })
        ]
    });
}
